// extracted by mini-css-extract-plugin
module.exports = {"map":"index_map__3PC_2"};